import React from 'react';

import { Row, Col, Typography, Button, Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';

import { ThumbnailItem, Fieldset } from 'common/components';

import * as getLink from 'utils/common/linkBuilder';
import { Images } from 'config/assets';
import classnames from 'classnames';

import './MemberMapping.less';

const { Text } = Typography;

const DummyMember = (props) => {
  const { text } = props;

  return (
    <div className='parent-child-member-mapping__dummy-wrapper'>
      <div className='parent-child-member-mapping__dummy'>
        <Text type='secondary'>{text && text}</Text>
      </div>
    </div>
  );
};

const MemberMapping = (props) => {
  const { originMember, childMember, onRemoveChildMember, onSwapMember } =
    props;

  return (
    <Row style={{ paddingBottom: 8, paddingTop: 8 }}>
      <Col style={{ paddingLeft: 12 }}>
        <Fieldset title='Parent Member'>
          <ThumbnailItem
            dataDetail={originMember}
            labelThumbnail={getLink.memberLink(
              originMember?.id || originMember?.companyId,
              originMember?.memberName,
              '_blank'
            )}
            imageThumbnail={
              originMember?.thumb300 ||
              originMember?.thumb ||
              originMember?.logo ||
              Images.RIVIR_LOGO_DEFAULT
            }
            hideCheckbox
            isMemberThumbnail
            className='parent-child-member-mapping__thumb'
          />
        </Fieldset>
      </Col>
      <Col
        flex={1}
        className={classnames('parent-child-member-mapping__moving')}
      >
        <Tooltip title='Swap the parent member with the child member'>
        <Button icon={<SwapOutlined />} onClick={onSwapMember} disabled={!childMember}/>
        </Tooltip>
      </Col>
      <Col style={{ paddingRight: 12 }}>
        <Fieldset title='Child Member'>
          {childMember ? (
            <div style={{ position: 'relative' }}>
              <ThumbnailItem
                dataDetail={childMember}
                labelThumbnail={getLink.memberLink(
                  childMember?.id,
                  childMember?.memberName,
                  '_blank'
                )}
                imageThumbnail={
                  childMember?.thumb300 ||
                  childMember?.thumb ||
                  childMember?.logo ||
                  Images.RIVIR_LOGO_DEFAULT
                }
                hideCheckbox
                isMemberThumbnail
                isShareBtn={false}
                className='parent-child-member-mapping__thumb'
              />
              <Button
                className='parent-child-member-mapping__btn-remove-target-member'
                danger
                type='primary'
                shape='circle'
                onClick={onRemoveChildMember}
              >
                <i class='fa fa-times' aria-hidden='true'></i>
              </Button>
            </div>
          ) : (
            <DummyMember text='Select Member' />
          )}
        </Fieldset>
      </Col>
    </Row>
  );
};

export default MemberMapping;
